var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M460-140v-80h-80v-40h80v-120.92q-76.69-8.62-128.35-65.5Q280-503.31 280-580.46q0-83.3 58.35-141.42Q396.69-780 480-780t141.65 58.12Q680-663.76 680-580.46q0 77.15-51.65 134.04-51.66 56.88-128.35 65.5V-260h80v40h-80v80h-40Zm20.12-280q66.34 0 113.11-46.89Q640-513.79 640-580.12q0-66.34-46.89-113.11Q546.21-740 479.88-740q-66.34 0-113.11 46.89Q320-646.21 320-579.88q0 66.34 46.89 113.11Q413.79-420 480.12-420Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.f594b7ee0c25755d800d4144043f3d92.svg";
export { ForwardRef as ReactComponent };